import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgChevronDown = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="m23.678 11.428-8.75 8.75a1.31 1.31 0 0 1-1.859 0l-8.75-8.75A1.314 1.314 0 1 1 6.18 9.57L14 17.391l7.821-7.823a1.314 1.314 0 1 1 1.86 1.86h-.003Z" />
  </svg>
);
export default SvgChevronDown;
